import React, { useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import { Box } from "@material-ui/core";
import DonutChart from "Components/charts/DonutChart";
import { useStyles } from "../styles";
import { NoResponseIcon } from "Assets/index";

const GenerateDonutChart = ({ data }) => {
  const classes = useStyles();
  const [selectedTarget, setSelectedTarget] = useState("");
  const [pieChartData, setPieChartData] = useState([]);

  useEffect(() => {
    const mappedData = (get(data, "userResponsePieChart") || []).map(
      (response) => {
        return {
          targetName: response.text,
          targetType: response.text,
          count: response.count,
          percentage: response.percentage,
          explode: response.text === selectedTarget,
          color: response.color,
          isImage: data.questionType === "EMOJIRANKING",
        };
      }
    );

    setPieChartData(mappedData);
  }, [get(data, "userResponsePieChart")]);

  return !isEmpty(pieChartData) ? (
    <Box className={classes.donutChart}>
      <DonutChart
        data={pieChartData}
        allTargetsCount={get(data, "totalUsers")}
        // centerText={"Users"}
        holeSize={50}
        selectedTarget={selectedTarget}
        setSelectedTarget={(selected) => {
          data.userResponsePieChart.map((e) =>
            e.targetType === selected
              ? { ...e, explode: true }
              : { ...e, explode: false }
          );
          setSelectedTarget(selected);
        }}
      />
    </Box>
  ) : (
    <Box textAlign="center">
      <NoResponseIcon />
      <p className="f-light-gray">No response found</p>
    </Box>
  );
};

export default GenerateDonutChart;
